import { cn } from "@forento/ui/utilities/tailwind"

const SelectedStatus: React.FC<{ isSelected: boolean }> = ({ isSelected }) => (
	<span
		className={cn(
			"inline-flex items-center gap-1.5 rounded px-2 py-1 text-xs font-medium",
			isSelected ? "bg-emerald-50 text-emerald-700" : "bg-component-background text-gray-500",
		)}
	>
		<span className="size-1.5 rounded-full bg-current" aria-hidden="true" />
		{isSelected ? "Published" : "Not published"}
	</span>
)

export default SelectedStatus
